import { ResellerCapabilities, ResellerProductTypeIds } from '../../constants';
import { Action } from '@wix/ambassador-premium-reseller-mgmt/types';
export const isResellerAggregation = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const capabilitiesSet = new Set([...request.capabilityNames, ResellerCapabilities.ADD_RESELLER_DOMAIN, ResellerCapabilities.BLOCK_DOMAIN_TRANSFER]);
  const {
    DomainsApiClient
  } = require('../ApiClients/DomainsApiClient');
  const capabilitiesResponse = await DomainsApiClient.query.capabilities({
    httpClient,
    request: {
      ...request,
      capabilityNames: Array.from(capabilitiesSet).sort()
    }
  });
  const areAllCapabilitiesEnabled = capabilitiesResponse ? Object.values(request.capabilityNames).every(capability => capabilitiesResponse[capability]) : false;
  if (!areAllCapabilitiesEnabled) {
    return {
      isReseller: false,
      resellerData: {}
    };
  }
  const resellerResponse = await DomainsApiClient.query.resellerData({
    httpClient,
    request: {
      productTypeId: ResellerProductTypeIds.DOMAIN,
      actions: [Action.CONNECT, Action.PURCHASE]
    }
  });
  return {
    isReseller: Object.keys(resellerResponse ?? {}).length > 0,
    resellerData: resellerResponse ?? {}
  };
};
//# sourceMappingURL=resellerAggregations.js.map